/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SuccessionManagementTalentRecommendationsAcknowledgeTalentRecommendationModel {
  type: SuccessionManagementTalentRecommendationsAcknowledgeTalentRecommendationModelTypeEnum;
  reasonForReject?: string | null;
}
export enum SuccessionManagementTalentRecommendationsAcknowledgeTalentRecommendationModelTypeEnum {
  Approve = 'Approve',
  Reject = 'Reject'
}
